import { supabase } from '@/integrations/supabase/client';

/**
 * Gera uma signed URL para o avatar a partir do path relativo.
 * Bucket agora é privado, requer autenticação.
 */
export const gerarUrlAvatar = async (avatarValue: string | null): Promise<string | null> => {
  if (!avatarValue || avatarValue.trim() === '') return null;

  // Se é uma URL completa legada, extrair o path relativo
  let relativePath = avatarValue;
  if (avatarValue.startsWith('http')) {
    const match = avatarValue.match(/storage\/v1\/object\/(?:public|sign)\/avatars\/(.+?)(\?|$)/);
    if (match) {
      relativePath = decodeURIComponent(match[1]);
    } else {
      return avatarValue; // Retorna a própria URL se for externa mas não do bucket de avatars
    }
  }

  // Gerar signed URL com validade de 1 hora
  const { data, error } = await supabase.storage
    .from('avatars')
    .createSignedUrl(relativePath, 3600);

  if (error || !data?.signedUrl) {
    console.warn('[avatar] Falha ao gerar signed URL:', error?.message);
    return avatarValue; // Fallback para o valor original se não conseguir gerar signed URL
  }

  return data.signedUrl;
};

/**
 * Gera uma signed URL para logos organizacionais ou de unidades.
 * Bucket 'tenant_assets' é privado.
 */
export const gerarUrlBranding = async (logoValue: string | null): Promise<string | null> => {
  if (!logoValue || logoValue.trim() === '') return null;

  // Se já for uma data URL ou blob, retorna como está
  if (logoValue.startsWith('data:') || logoValue.startsWith('blob:')) return logoValue;

  // Se for uma URL completa, tentamos identificar o bucket
  let bucket = 'tenant_assets';
  let relativePath = logoValue;

  if (logoValue.startsWith('http')) {
    // Identifica se a URL pertence a um bucket conhecido do Supabase
    // Adicionamos suporte para URLs públicas e assinadas
    const match = logoValue.match(/storage\/v1\/object\/(?:public|sign)\/([^\/]+)\/(.+?)(\?|$)/);
    
    if (match) {
      bucket = match[1];
      relativePath = decodeURIComponent(match[2]);
    } else {
      return logoValue; // URL externa padrão
    }
  }

  // Gerar signed URL com validade de 2 horas para branding
  try {
    const { data, error } = await supabase.storage
      .from(bucket)
      .createSignedUrl(relativePath, 7200);

    if (error || !data?.signedUrl) {
      console.warn(`[branding] Falha ao gerar signed URL para bucket ${bucket} e path ${relativePath}:`, error?.message);
      return logoValue;
    }

    return data.signedUrl;
  } catch (err) {
    console.error(`[branding] Erro ao processar signed URL:`, err);
    return logoValue;
  }
};
